export default __webpack_public_path__ + "static/media/twoTrucksTablet.b2771b03.jpg";